import { fluidResolvers } from '@1delta/data-sdk'
import { Call } from '../../../utils/multicall'

/**
 * Number of multicall slots consumed by one `positionsByUser(account)` call.
 *
 * This is always 1 — the resolver returns every position across every vault
 * in one shot as `(UserPosition[], VaultEntireData[])`. No per-vault
 * fan-out needed.
 */
export const FLUID_USER_CALL_COUNT = 1

/**
 * Build the user-data multicall descriptor for Fluid vaults.
 *
 * Single call: `VaultResolver.positionsByUser(account)` returns two parallel
 * arrays — `UserPosition[]` (supply/borrow raw amounts per NFT) and
 * `VaultEntireData[]` (full vault metadata for each position's vault).
 *
 * The parser groups by `constantVariables.vaultId` and emits one `UserData`
 * per vault under `FLUID_<vaultId>`, matching the multi-market pattern.
 */
export const buildFluidUserCall = (
  chainId: string,
  _lender: string,
  account: string,
): Call[] => {
  const resolvers = fluidResolvers()?.[chainId]
  if (!resolvers) return []

  return [
    {
      address: resolvers.vaultResolver,
      name: 'positionsByUser',
      params: [account],
    },
  ]
}
